

<!-- <div *ngIf="mappedTedDomainData().length === 0" style="text-align: center; margin: 90px 0">
  <img src="../../assets/img/loader.gif" />
</div> -->
<div class="no-domain-parent" *ngIf="mappedTedDomainData().length === 0" >
  <div class="no-domain-information">No domain information available</div>
  <div class="no-domain-notes">This protein does not currently have any structural domains identified. Domain annotations will appear here if data becomes available in future updates.</div>
</div>

<div *ngIf="mappedTedDomainData().length > 0">
  <section *ngIf="isOldUniprotEntry" class="notification">
    <notification-msg 
        [type]="'warning'" 
        [message]="'This AlphaFold model was generated using a prior version of the UniProt sequence.'">
    </notification-msg>
  </section>
  <main *ngIf="tedDomainData().length > 0" class="tab-parent" [class.change-display]="!isSidebarDisplayed()">
  
    @if(isSidebarDisplayed()){
    <interactive-left-table tabName="Domains" [tedDomainData]="mappedTedDomainData()"
      (handleSelectedCard)="handleSelectedCard($event)" />
    }
    <div class="tab-content">
      @let icon = isSidebarDisplayed() ? 'left' : 'right'; @let text = isSidebarDisplayed() ? 'Open full-width' : 'Show
      Domains';
      <button class="vf-button-ghost" (click)="toggleSidebar()">
        <img [src]="'assets/img/two_arrows_' + icon + '.png'" alt="arrow icons" />
        <span class="openclosetext">{{text}}</span>
      </button>
  
      <h5 class="domain-title">
        <strong><span>Domain</span> {{ activeDomain()?.tedNumber }}</strong>
      </h5>
      <section class="domain-info">
        <div class="domain-info-grouped">
          <div class="info-row">
            <span>
              Source
            </span>
            <article>
              <a href= "https://ted.cathdb.info/uniprot/{{uniprotAccession}}" target= "_blank" (click)="gaService.eventEmitter('external_link_click', 'external_resources', 'click', 'ted_entry_link', 'Clicks on TED link')">TED
              <svg class="targetbl" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M3.33333 3.33333V12.6667H12.6667V8H14V12.6667C14 13.4 13.4 14 12.6667 14H3.33333C2.59333 14 2 13.4 2 12.6667V3.33333C2 2.6 2.59333 2 3.33333 2H8V3.33333H3.33333ZM9.33333 3.33333V2H14V6.66667H12.6667V4.27333L6.11333 10.8267L5.17333 9.88667L11.7267 3.33333H9.33333Z" fill="#3B6FB6"/>
              </svg>
            </a>
            </article>
          </div>
  
          <div class="info-row" *ngIf="activeDomain().label !== '-'" >
            <span>CATH</span>
            <article>
              <a [href]="
                'https://www.cathdb.info/version/v4_4_0/cathnode/' + activeDomain().label" target="_blank"  (click)="gaService.eventEmitter('external_link_click', 'external_resources', 'click', 'cath_link', 'Clicks on domain CATH link')"
                >{{ activeDomain().label }} 
              <svg class="targetbl" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M3.33333 3.33333V12.6667H12.6667V8H14V12.6667C14 13.4 13.4 14 12.6667 14H3.33333C2.59333 14 2 13.4 2 12.6667V3.33333C2 2.6 2.59333 2 3.33333 2H8V3.33333H3.33333ZM9.33333 3.33333V2H14V6.66667H12.6667V4.27333L6.11333 10.8267L5.17333 9.88667L11.7267 3.33333H9.33333Z" fill="#3B6FB6"/>
              </svg>
            </a>
            </article>
          </div>
          <div class="info-row" *ngIf="activeDomain().label == '-'" >
            <span>CATH</span>
            <article>
              No match
            </article>
          </div>
          <div class="info-row">
            <span>Quality 
              <help-icon-with-tooltip [tooltipText]="'Overall confidence in the domain assignment.'" [isOnlytext]="false" />
            </span>
            <article>{{ activeDomain()?.quality }} 
              <span *ngIf="activeDomain().quality === 'High-confidence'">
                <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none">
                  <path d="M3.232 14.272L4.944 9.184L0.816 6.416H5.872L7.68 0.959999L9.52 6.416H14.544L10.416 9.184L12.16 14.272L7.68 11.024L3.232 14.272Z" fill="#1A1C1A"/>
                </svg>
                <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none">
                  <path d="M3.232 14.272L4.944 9.184L0.816 6.416H5.872L7.68 0.959999L9.52 6.416H14.544L10.416 9.184L12.16 14.272L7.68 11.024L3.232 14.272Z" fill="#1A1C1A"/>
                </svg>
              </span>
              <span *ngIf="activeDomain().quality === 'Moderate'">
                <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none">
                  <path d="M3.232 14.272L4.944 9.184L0.816 6.416H5.872L7.68 0.959999L9.52 6.416H14.544L10.416 9.184L12.16 14.272L7.68 11.024L3.232 14.272Z" fill="#1A1C1A"/>
                </svg>
              </span>
              <span *ngIf="activeDomain().quality === 'Uncertain'">
                
              </span><br/>
              <span ><span class="innertext">Qscore: {{ activeDomain()?.qscore }} </span></span><br/>
              <span><span class="innertext">Assignment: {{ activeDomain().cath_assignment_level === '-' ? 'No assignment' : activeDomain().cath_assignment_level }} </span> </span>
              
            </article>
          </div>
        </div>
        <div class="domain-info-grouped">
          <div class="info-row">
            <span>
              Boundaries
              <help-icon-with-tooltip [tooltipText]="'Start–end positions of all segments in the domain. Domains may consist of multiple non-contiguous segments.'" [isOnlytext]="false" />
            </span>
            <article> {{ activeDomain()?.boundaries }}</article>
          </div>
  
          <div class="info-row">
            <span>
              Length
              <help-icon-with-tooltip [tooltipText]="'Total residues across all segments (excluding gaps between them).'" [isOnlytext]="false" />
            </span>
            <article>
                {{ activeDomain()?.length }}
            </article>
          </div>
          @if(activeDomain().plddt){
          <div class="info-row">
            <span>
              Average pLDDT
              <help-icon-with-tooltip [tooltipText]="'Mean pLDDT score for residues in the domain (gaps excluded). Indicates AlphaFold confidence.'" [isOnlytext]="false" />
            </span>
            <article>
              {{ activeDomain().plddt | number:'1.2-2' }}
            </article>
          </div>}
        </div>
      </section>
      <section>
        <div class="sequence-container">
          <div class="title">
            <span class="text">
              {{ entryData().uniprotDescription }},
              Sequence length {{ (entryData().sequenceEnd - entryData().sequenceStart) + 1 }}
            </span>
            <div class="label-tooltip-seq" style="display: inline">
              <span *ngIf="isCopySequence" class="label-tooltip-seq-text">
                Sequence copied
              </span>
              <button (click)="copySequence(entryData().sequence)">Copy sequence</button>
            </div>
          </div>
          <!-- <div class="sequence">
            <span *ngFor="let fragment of highlightedSequence"
              [ngStyle]="{'background-color': fragment.highlight ? '#C4D6E8' : 'transparent'}">{{ fragment.text }}</span>
          </div> -->
          <div class="domains-sequencepanel"></div>
        </div>
      </section>
      
      <section class="molstar-details-container">
        <div class="threedwrapper">
          <div class="domain-title"> Domains</div>
          <div class="paecontainer">
              <app-ted-domains
              [tedDomainData]="tedDomainData()"
              [lengthOfProtein]="entryData().sequenceEnd"
              [pdbeMolstar]="pdbeMolstar"
              [selectedDomain]="tedDomainNumberForClickActive()"
              (handleSelectedDomain)="handleSelectedCard($event)"
            ></app-ted-domains>
  
            <app-pae-view *ngIf="entryData().paeDocUrl" [accession]="accession" [paeid]="'domains-paeviewer'"
              [paeDocUrl]="entryData().paeDocUrl" [imageUrl]="entryData().paeImageUrl" [length]="entryData().sequenceEnd"
              (selectedRegion)="cmSelectionUpdate($event)">
            </app-pae-view>
          </div>
         
        </div>
  
        <div class="threedcontainer">
          <div class="dropdownContainer">
            <span class="colorbytext">Colour by </span>
            <entry-dropdown
              [downloadable]="false"
              [islink]="false"
              [options]="dropdownOptions"
              [title]="dropdownSelected"
              (optionClickedEvent)="onDropdownSelect($event)">
            </entry-dropdown>
          </div>
          <div class="domains-molstar-container"></div>
          
          <div *ngIf="!dropdownSelected.includes('Domain')">
          <linear-legends type="plddt"></linear-legends>
          </div> 
         
        </div>
      </section>
    </div>
  </main>
</div>
